module.exports = __webpack_public_path__ + "img/case3.d1d20af9.png";